import { Box, Typography } from '@mui/material';
import React from 'react';

import cardDishShadow from './../image/card3/dish-shadow.png';
import cardDish from './../image/card3/dish.png';
import cardSolid from './../image/card3/card.svg';
import cardDashes from './../image/card3/dashes.svg';
import cardTitlebox from './../image/card3/text-box/box.svg';
import carddot1 from './../image/card3/text-box/dot1.svg';
import carddot2 from './../image/card3/text-box/dot2.svg';
import cardDishSlice from './../image/card3/dishSlice.svg';
function Card() {
  const cardStyle = {
    width: '275px',
    height: '330px',
    position: 'relative',
    '& img': {
      position: 'absolute',
    },
  };
  return (
    <Box sx={cardStyle}>
      <img
        style={{ zIndex: '2', top: '0', left: '0' }}
        src={cardSolid}
        width={'100%'}
        height={'100%'}
      />
      <img
        style={{ zIndex: '1', top: '-10px', right: '-15px' }}
        src={cardDashes}
        width={'100%'}
        height={'100%'}
      />
      <Box
        sx={{
          width: '125px',
          height: '65px',
          position: 'absolute',
          top: '60px',
          right: '45px',

          boxSizing: 'content-box',

          '&:before': {
            content: '""',
            background: `url(${carddot1})`,
            width: '15.1px',
            height: '14.69px',

            position: 'absolute',

            backgroundPosition: 'center',
            backgroundSize: 'contain',
            zIndex: '5',
            backgroundRepeat: 'no-repeat',
            left: '3px',
            top: '-10px',
          },
          '&:after': {
            content: '""',
            background: `url(${carddot2})`,
            width: '15.1px',
            height: '14.69px',

            position: 'absolute',

            backgroundPosition: 'center',
            backgroundSize: 'contain',
            zIndex: '5',
            backgroundRepeat: 'no-repeat',
            left: '12px',
            top: '-18px',

            transform: 'rotate(5deg)',
          },
        }}
      >
        <img
          style={{ zIndex: '3', width: '100%' }}
          src={cardTitlebox}
          width={'100%'}
          height={'100%'}
        />
        <Typography
          sx={{
            zIndex: '5',
            position: 'relative',
            top: '15px',
            left: '11px',
            padding: '0 5px',
            boxSizing: 'border-box',
            textAlign: 'center',
            transform: 'rotate(8deg)',
            width: '82%',
            fontFamily: 'Caveat Brush',
            fontSize: '13px',
            fontWeight: '400',
            letterSpacing: '0em',
            textAlign: 'center',
            color: '#775835',
          }}
        >
          Chicken Masala
        </Typography>
      </Box>
      <Box
        sx={{
          zIndex: '4',
          width: '175px',
          height: '175px',
          position: 'absolute',
          bottom: '16px',
          left: '0',
          right: '0',
          margin: 'auto',

          '&:before': {
            content: '""',
            background: `url(${cardDishSlice})`,
            width: '100px',
            height: '170px',
            position: 'absolute',
            left: '-34px',
            top: '-5px',
            transform: 'rotate(-1deg)',
            WebkitBackgroundSize: 'contain',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
          },
        }}
      >
        <img
          style={{
            zIndex: '4',
          }}
          src={cardDish}
          width={'100%'}
          height={'100%'}
        />
        <img
          style={{
            bottom: '-60px',
            zIndex: '3',
          }}
          src={cardDishShadow}
          width={'100%'}
          height={'100%'}
        />
      </Box>
    </Box>
  );
}

export default Card;
